import React from 'react';
import {
    Box,
    Text,
    Flex,
    IconButton,
} from "@chakra-ui/react";
import { DeleteIcon, CheckIcon } from "@chakra-ui/icons";
import { fileSize } from '../../utils/helper';

export const AudioCard = ({ audio, onDelete, isHideDelete = false, isSelection = false, selectMedia, mediaUrl }) => {
    
    const url = !Array.isArray(mediaUrl) ? [mediaUrl] : mediaUrl
    const size = fileSize(audio)
    return (
        <Box
            key={audio.id}
            bg="white"
            boxShadow="md"
            borderRadius="lg"
            overflow="hidden"
            position="relative"
            _hover={{ transform: "scale(1.02)", transition: "0.2s" }}
            backgroundColor={url.includes(audio.url) ? "blue.200" : "white"}
            onClick={isSelection ? () => selectMedia("images", audio.url, audio) : null}
        >
            <Box width="100%" textAlign="center" p={2}>
                <audio controls style={{ width: "100%" }}>
                    <source src={audio.url} type="audio/mp3" />
                    Your browser does not support the audio element.
                </audio>
            </Box>

            <Box p={2}>
                <Text fontWeight="bold" isTruncated>
                    {audio.name}
                </Text>
                <Flex justify="space-between" mt={2} align="center">
                    <Text fontSize="sm" color="gray.500">
                        {size}
                    </Text>
                    {
                        !isHideDelete ?
                            <IconButton
                                aria-label="Delete"
                                icon={<DeleteIcon />}
                                size="sm"
                                variant="ghost"
                                colorScheme="red"
                                onClick={(e) => {
                                    e.stopPropagation();
                                    onDelete(audio.id)
                                }}
                            /> :
                            <>
                                {
                                    url.includes(audio.url) ?
                                        <CheckIcon color="blue.500" /> : <></>
                                }
                            </>
                    }
                </Flex>
            </Box>
        </Box>
    );
}
